import React from "react";
import HeroSection from "../../components/HeroSection/HeroSection";
import ContactUs from "../../components/GetInTouch/GetInTouch";
import getintouch from "../../assets/images/getintouch.jpg";
import "./GetInTouch.css";
import Map from "../../components/Map/Map";
import { Helmet } from "react-helmet";

export default function GetInTouch() {
  return (
    <div className="getintouch_page">
      <Helmet>
        <title>Get In Touch | Elegro Energy Limited</title>
        <link rel="canonical" href="/getintouch" />
        <meta name="robots" content="index, follow" />
        <meta
          name="description"
          content="Elegro Energy Limited is always available to attend to your needs. Do reach out to us through the contacts provided."
        />
      </Helmet>
      <HeroSection
        heroTitle="Do Get In Touch With Us."
        heroParagraph="A highly successful and experienced trading and construction company."
        btnLink="/projects"
        btnText="View Projects"
        heroImage={getintouch}
      />
      <ContactUs />
      <Map />
    </div>
  );
}
